<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-04-01 17:46:42
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>ZtoWebrtc</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const url = "https://uedcdn.zto.com/static/webrtc/";
export default {
  name: "zto-webrtc",
  data() {
    return {
      fileList: [
        {
          label: "灰度",
          linkList: [
            url + "new-pre-release/zto-webrtc-web.umd.min.js",
            url + "stable/SilkVoiceRTC.min.js"
          ]
        },
        {
          label: "正式版",
          linkList: [
            url + "release/zto-webrtc-web.umd.min.js",
            url + "stable/SilkVoiceRTC.min.js"
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListWebrtc.vue